import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    MarkNotificationRead as MarkReadMutation,
    MarkNotificationReadVariables as MarkReadVariables,
} from 'nutshell-graphql-types';

import {nutApolloClient} from '../../../../apollo-client';

import NOTIFICATION_FRAGMENT from '../fragments/notification-fragment.graphql';
import MarkNotificationRead from '../mutations/mark-notification-read.graphql';

export const useMarkNotificationRead = (): {
    markRead: (notificationId: string) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [markRead, {loading, error}] = useMutation<MarkReadMutation, MarkReadVariables>(
        MarkNotificationRead
    );

    return {
        markRead: (notificationId: string) => {
            const notificationFragment = nutApolloClient.readFragment({
                id: notificationId,
                fragmentName: 'NotificationFragment',
                fragment: NOTIFICATION_FRAGMENT,
            });

            return markRead({
                variables: {
                    id: notificationId,
                },
                optimisticResponse: notificationFragment
                    ? {
                          notificationMarkRead: {
                              __typename: 'NotificationMarkReadPayload',
                              notification: {
                                  ...notificationFragment,
                                  readStatus: 'READ',
                              },
                          },
                      }
                    : undefined,
            });
        },
        isLoading: loading,
        // @ts-expect-error
        error: error && safelyGetGraphQLErrorMessage(error),
    };
};
